export default __webpack_public_path__ + "static/media/instagram-logo.b6a88fac.svg";